
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/institucional/[landingSlug]",
      function () {
        return require("private-next-pages/institucional/[landingSlug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/institucional/[landingSlug]"])
      });
    }
  